import React from 'react';
import { autobind } from 'core-decorators';
import { FormGroup, Alert, Input } from 'reactstrap';
import { injectIntl } from 'react-intl';

import { capitalizeFirstLetter } from 'src/utils/string';
import Info from '../info';
@autobind
class Radio extends React.Component {
  static defaultProps = {
    inline: true,
    needId: false,
    showLabel: true,
    hintItens: null,
    descriptionItems: null,
    optionSpacing: null,
    style: null,
    hintLabel: 'label',
    colunaUnica: false,
    required: false,
    optionLabelStyle: null,
  };

  handleChangeRadio(value) {
    let item = this.props.options.find((i) => i.id == value.id);

    if (this.props.needId) {
      this.props.model.requestChange(item.id);
    } else {
      this.props.model.requestChange(item);
    }

    this.triggerChange(item);

    if (this.props.getAlteracao != null) this.props.getAlteracao();
  }

  triggerChange(changedValue) {
    const onChange = this.props.onChange;
    if (onChange) {
      onChange(changedValue);
    }
  }

  getLabel(item) {
    if (this.props.labelFunction) return this.props.labelFunction(item);

    if (this.props.labelField) return item[this.props.labelField];

    return item;
  }

  renderHint(item, hintItens, hintKey) {
    const hint = hintItens.find((i) => i.id == item.id);

    if (hint && hint[this.props.hintLabel]) {
      return (
        <Info
          style={{ alignSelf: 'flex-start' }}
          id={`hint-${hint.id}-${hintKey}`}
          placement="right"
          text={capitalizeFirstLetter(hint[this.props.hintLabel])}
        />
      );
    }
  }

  renderDescription(item, descriptionItems) {
    if (!descriptionItems) return null;

    const description = descriptionItems.find((i) => i.id === item.id);

    if (description && description.label) {
      return (
        <div
          style={{
            fontSize: '12px',
            color: 'rgba(161, 161, 170, 1)',
            lineHeight: '1.5',
          }}
        >
          {capitalizeFirstLetter(description.label)}
        </div>
      );
    }
    return null;
  }

  isChecked(item) {
    const { model, needId } = this.props;

    if (model.value === null || model.value === undefined) return false;

    return needId
      ? String(item.id) === String(model.value)
      : item.id === model.value.id;
  }

  render() {
    const {
      model,
      disabled,
      name,
      options,
      className,
      inline,
      inColum,
      showLabel,
      style,
      hintItens,
      descriptionItems,
      optionSpacing,
      absolute,
      hintKey = '',
      colunaUnica,
      required,
      optionLabelStyle,
    } = this.props;

    return (
      <FormGroup
        style={style}
        className={className}
        validationstate={model.errors ? 'error' : null}
      >
        <div style={{ color: model.errors ? 'red' : null }}>
          {showLabel && model.label && (
            <label className="control-label">
              {model.label} {required ? '*' : ''}
            </label>
          )}
          <div className="radio-option-container">
            {options &&
              options.map((item, index) => (
                <div
                  key={`div-options-${index}`}
                  className={`radio-option-item ${
                    inline ? 'form-check-inline' : ''
                  } ${
                    inColum
                      ? colunaUnica
                        ? 'col-md-5 d-flex flex-column align-items-start justify-content-center'
                        : 'col-md-5'
                      : ''
                  }`}
                  style={
                    inline
                      ? {}
                      : {
                          marginBottom:
                            optionSpacing !== null &&
                            optionSpacing !== undefined
                              ? optionSpacing
                              : descriptionItems
                              ? '12px'
                              : '8px',
                        }
                  }
                >
                  <div
                    className={`radio-option-content c-radio d-flex ${
                      descriptionItems
                        ? 'align-items-start flex-column'
                        : 'align-items-center'
                    }`}
                    key={index}
                  >
                    <div className="d-flex align-items-center">
                      <label
                        className="radio-option-label mr-2"
                        style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          ...(descriptionItems ? { fontWeight: 'bold' } : {}),
                          ...(optionLabelStyle || {}),
                        }}
                      >
                        {absolute ? (
                          <Input
                            type="radio"
                            disabled={disabled || item.disabled}
                            name={`${name}-${index}`}
                            checked={this.isChecked(item)}
                            onChange={this.handleChangeRadio.bind(this, item)}
                          />
                        ) : (
                          <Input
                            type="radio"
                            disabled={disabled || item.disabled}
                            name={`${name}-${index}`}
                            checked={this.isChecked(item)}
                            onChange={this.handleChangeRadio.bind(this, item)}
                            className="mr-1"
                            style={{ position: 'relative', marginTop: 2 }}
                          />
                        )}
                        {this.getLabel(item)}
                      </label>
                      {hintItens && this.renderHint(item, hintItens, hintKey)}
                    </div>
                    {descriptionItems &&
                      this.renderDescription(item, descriptionItems)}
                  </div>
                </div>
              ))}
          </div>
          {model.erros && <Alert>{model.erros}</Alert>}
        </div>
      </FormGroup>
    );
  }
}

export default injectIntl(Radio);
